import { useState, useRef, useEffect } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import NavBar from '../../../../component/b2c/navBar/navBar';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import { useForm } from 'react-hook-form';
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaCalculator, FaUser, FaShoppingCart, FaBox } from 'react-icons/fa';
import { useMyContext } from '../../../../context/MyContext';
import GoogleAddressInput from "../../../../component/autoFillAddress/addressAutoFill";
import { Controller } from "react-hook-form";
import '../../../../css/custom-scrollbar.css';
import Select from "react-dropdown-select";
import ViewRateForword from '../../../../component/b2c/models/ViewRateForwordShipmet';
import { Base_Url, getpincode, addShipment, allwarehouseslist } from '../../../../config/config';
import { toast } from 'react-toastify';
import Spinner from '../../../../component/spinner/spinner';
import axios from 'axios';
import UploadBulk from '../../../../component/b2c/models/UploadBulk';
const schema = z.object({
    warehouse: z.string().nonempty("Warehouse is required"),

    firstName: z
        .string()
        .trim()
        .min(1, "First Name is required")
        .regex(/^[a-zA-Z\s\-'\.]+$/, "First Name must only contain alphabetic characters")
        .refine((val) => val.trim().length > 0, {
            message: "First Name cannot be only spaces",
        }),

    lastName: z
        .string()
        .trim()
        .min(1, "Last Name is required")
        .regex(/^[a-zA-Z\s\-'\.]+$/, "Last Name must only contain alphabetic characters")
        .refine((val) => val.trim().length > 0, {
            message: "Last Name cannot be only spaces",
        }),

    email: z
        .string()
        .optional()
        .refine((val) => !val || z.string().email().safeParse(val).success, {
            message: "Please enter a valid email address",
        }),

    mobile: z
        .string()
        .trim()
        .refine((val) => /^\d{10}$/.test(val), {
            message: "Mobile number must be exactly 10 digits",
        }),

    address: z
        .string()
        .trim()
        .min(10, "Full Address must be at least 10 characters")
        .refine((val) => val.trim().length >= 10, {
            message: "Address cannot be only spaces",
        }),

    pincode: z
        .string()
        .trim()
        .refine((val) => /^\d{6}$/.test(val), {
            message: "Pincode must be exactly 6 digits",
        }),

    city: z
        .string()
        .trim()
        .min(1, "City is required")
        .regex(/^[a-zA-Z][a-zA-Z\s().,'-]*$/, "City contains invalid characters"),

    state: z
        .string()
        .trim()
        .min(1, "State is required")
        .regex(/^[a-zA-Z\s\-]+$/, "State must only contain alphabetic characters"),

    orderId: z
        .string()
        .trim()
        .min(1, "Order ID is required")
        .refine((val) => val.trim().length > 0, {
            message: "Order ID cannot be only spaces",
        }),

    invoiceAmount: z
        .string()
        .trim()
        .min(1, "Invoice Amount is required")
        .refine((val) => val.trim().length > 0 && /^\d*\.?\d+$/.test(val), {
            message: "Invoice Amount must be a valid number",
        }),

    paymentMode: z
        .string()
        .trim()
        .min(1, "Payment Mode is required")
        .refine((val) => val.trim().length > 0, {
            message: "Payment Mode cannot be only spaces",
        }),

    productDes: z
        .string()
        .trim()
        .min(1, "Product Description is required")
        .refine((val) => val.trim().length > 0, {
            message: "Product Description cannot be only spaces",
        }),

    // Fixed: Remove duplicate codAmount field
    codAmount: z
        .string()
        .optional()
        .refine((val) => !val || (val.trim().length > 0 && !/^\s+$/.test(val)), {
            message: "COD Amount cannot be only spaces",
        }),

    weight: z.preprocess(
        (val) => (val === '' || val === undefined || val === null) ? undefined : Number(val),
        z.number()
            .int("Weight must be a whole number")
            .min(50, "Weight must be at least 50 gm")
    ),

    length: z
        .string()
        .min(1, "Length is required")
        .refine((val) => /^\d*\.?\d+$/.test(val) && parseFloat(val) > 0, {
            message: "Length must be a positive number"
        }),

    width: z
        .string()
        .min(1, "Width is required")
        .refine((val) => /^\d*\.?\d+$/.test(val) && parseFloat(val) > 0, {
            message: "Width must be a positive number"
        }),

    height: z
        .string()
        .min(1, "Height is required")
        .refine((val) => /^\d*\.?\d+$/.test(val) && parseFloat(val) > 0, {
            message: "Height must be a positive number"
        }),
});

export default function ReverseShipment() {
    const { isDarkMode, isToggleSidebar,setIsPageLoading } = useMyContext()
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [uploadBulkPopupOpen, setUploadBulkPopupOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [tableData, setTableData] = useState(null);
    // const [isTableVisible, setIsTableVisible] = useState(false);
    const Navigation = useNavigate();
    const [wareHouseList, setwareHouseList] = useState([])
    const [wareHouseId, setwareHouseId] = useState('')
    const [wareHousePincode, setwareHousePincode] = useState('');

    const [reqBody, setReqBody] = useState([]);
    const fileInputRef = useRef(null);

    const { register, handleSubmit, formState: { errors }, reset, watch, trigger, setValue, control } = useForm({
        resolver: zodResolver(schema),
    });


    const handleViewClick = () => {
        setIsPopupOpen(true);
    };
    const handleClose = () => {
        setIsPopupOpen(false);
    };

    const UploadBulkViewClick = () => {
        setUploadBulkPopupOpen(true);

    }

    const handleCloseUploadBulk = () => {
        setUploadBulkPopupOpen(false);

    };

    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');


    const pincode = watch("pincode");

    useEffect(() => {
        if (pincode && pincode.length === 6) {
            fetchPincodeData(pincode);
        }
    }, [pincode]);


    const fetchPincodeData = async (pincode) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const urlgetPincode = `${Base_Url}${getpincode}?pincode=${pincode}`;
        try {
            // const response = await fetch(`http://192.168.1.36/backendci4/api/getpincode?pincode=${pincode}`, {
            const response = await fetch(urlgetPincode, {
                method: 'GET',
                headers: {
                    // 'token': "eyJ1c2VyX2lkIjoiNTkiLCJleHBpcmVzX2F0IjoxNzI4NzEzMzM4fQ==",
                    'token': token,
                    'cus_id': cus_id,
                    'Content-Type': 'application/json'
                }
            });


            const data = await response.json();
            if (data && data.status === "SUCCESS") {
                let { city, state } = data.data[0];
                city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
                state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
                setValue("city", city);
                setValue("state", state);
            } else if (data && data.status === "FAIL") {
                setValue("city", "");
                setValue("state", "");
                toast.error(data.message);
            } else {
                toast.error("Failed to fetch city and state data");
            }

        } catch (error) {
            console.error('Error fetching pincode data:', error);
            toast.error("Error fetching pincode data");
        }
    };

    const paymentMode = watch("paymentMode");

    useEffect(() => {
        if (paymentMode === "prepaid") {
            setValue("codAmount", "0");
        } else if (paymentMode === "cod") {
            setValue("codAmount", "");
        }
    }, [paymentMode, setValue]);

    const handleInputChange = (event) => {
        const { value, id } = event.target;

        if (['pincode', 'mobile', 'boxQty', 'orderId'].includes(id)) {
            const filteredValue = value.replace(/[^0-9]/g, '');
            event.target.value = filteredValue;

            if (id === "pincode") {
                if (filteredValue.length < 6) {
                    setValue("city", "");
                    setValue("state", "");
                } else if (filteredValue.length === 6) {
                    fetchPincodeData(filteredValue);
                }
            }
        }

        if (['firstName', 'lastName', 'city', 'state'].includes(id)) {
            const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
            event.target.value = filteredValue;
        }
    };


    useEffect(() => {
        fetchWareHouseList()
    }, [])

    const fetchWareHouseList = async () => {
        const token = localStorage.getItem('token');
        const cusid = localStorage.getItem('cus_id');
        const headers = new Headers({
            'token': token,
            'cus_id': cusid,
            'Content-Type': 'application/json'
        });

        try {
            const response = await fetch(Base_Url + allwarehouseslist, {

                method: 'GET',
                headers: headers
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            const transformedData = data.data.map(warehouse => ({
                value: warehouse.id,
                label: warehouse.name,
                pincode: warehouse.pincode
            }));
            setwareHouseList(transformedData)
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const handleNaviagtion = () => {
        Navigation("/dashboard");

    }

    const onSubmit = async (data) => {
        const { weight } = data;

        if (weight > 20000) {
            Swal.fire({
                title: "Weight Limit Exceeded!",
                text: "The weight cannot exceed 20kg. Please adjust the value.",
                icon: "error",
                confirmButtonText: "Okay",
            });
            return;
        }

        setIsSubmitting(true);
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const requestBody = {
            customer: {
                first_name: data.firstName,
                last_name: data.lastName,
                email: data.email,
                phone: data.mobile,
                address_type: "home",
            },
            droplocation: {
                address: data.address,
                city: data.city,
                state: data.state,
                country: "India",
                pin: data.pincode,
            },
            pickuplocation: {
                warehouse_id: wareHouseId,
            },
            product: {
                // products_desc: data.productDes,
                product_desc: data.productDes,
                quantity: "1",
                total_amount: data.invoiceAmount,
                cod_amount: data.codAmount,
                payment_mode: data.paymentMode,
                shipment_type: "Reverse"
            },
            dimension: {
                length: data.length,
                width: data.width,
                height: data.height,
                weight: data.weight,
            },
        };
        setReqBody(requestBody);
        try {
            const response = await axios.post(Base_Url + addShipment, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': token,
                    'cus_id': cus_id,
                },
            });

            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                setTableData(response.data);
                handleViewClick();
                Navigation("/shipments/all");
                setIsSubmitting(false);
            } else {
                toast.error(response.data.message || "Something went wrong. Please check the data.");
                 setIsSubmitting(false);
            }

        } catch (error) {
            const messages = error?.response?.data?.messages;

            let apiError = "Something went wrong!";

            if (typeof messages === "string") {
                apiError = messages;
            } else if (typeof messages === "object" && messages !== null) {
                const firstKey = Object.keys(messages)[0];
                apiError = messages[firstKey];
                 setIsSubmitting(false);
            } else {
                apiError = error?.message || "Something went wrong!";
                 setIsSubmitting(false);
            }
            toast.error(apiError);
             setIsSubmitting(false);
        }
    };

    return (
        <>
            <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                <div className="z-10">
                    <NavBar />
                </div>
                <div className="flex flex-1 overflow-hidden">
                    {isToggleSidebar && (
                        <div
                            className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
                            style={
                                window.innerWidth < 768
                                    ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                    : {}
                            } >
                            <Sidebar />
                        </div>
                    )}
                    <div
                        // {`${isDarkMode ? "dark:bg-darkmodeColor text-white shadow-none" : ""} w-full  overflow-auto transition-all duration-300  shadow-custom-light rounded-custom }`}
                        className={`flex-1 sm:mt-3 overflow-auto transition-all duration-300 custom-scrollbar  rounded-custom md:ml-4 md:mr-4 md:mr-4 md:mb-4 ${isToggleSidebar ? 'md:ml-0' : 'md:ml-0'} ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white shadow-custom-dark" : "bg-white"}`}
                    >
                        <div className="container overflow-x-hidden  mx-auto pl-6 pr-6 pt-4 pb-2 ">
                            <div className="flex flex-col md:flex-row mb-3 gap-2 md:gap-8">
                                <button onClick={handleNaviagtion}
                                    className="w-full md:w-[48%] bg-customPurple hover:bg-purple-700 text-white py-2 rounded-md flex items-center justify-center">
                                    <IoMdArrowRoundBack className="mr-2" />
                                    Create Reverse Order
                                </button>
                                <button
                                    className="w-full md:w-[48%] bg-customPurple hover:bg-purple-700 text-white py-2 rounded-md flex items-center justify-center"
                                    onClick={UploadBulkViewClick}
                                >
                                    <FaBox className="mr-2" />
                                    Upload Bulk
                                </button>
                            </div>
                            <UploadBulk
                                isopen={uploadBulkPopupOpen}
                                onClose={handleCloseUploadBulk}
                            />
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="px-8 pt-6 pb-8 mb-4 font-sans shadow-custom-light dark:shadow-custom-dark rounded-custom w-full">
                                    <h2 className="text-xl font-bold mb-4 text-custom-blue flex items-center">
                                        <FaUser className="mr-2 text-custom-blue" />
                                        Customer Details
                                    </h2>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                                        <div className="relative">
                                            <label htmlFor="warehouse" className="block text-sm font-medium mb-1">Warehouse</label>

                                            <select
                                                id="warehouse"
                                                {...register("warehouse")}
                                                className={`p-2 appearance-none  rounded-custom border w-full focus:outline-none focus:shadow-outline pr-10
  ${isDarkMode ? "bg-darkmodeColor text-white" : "bg-white text-darkmodeColor"}`}
                                                onChange={(e) => {
                                                    const selectedValue = e.target.value;
                                                    const selectedItem = wareHouseList.find((item) => item.value === selectedValue);

                                                    if (selectedItem) {
                                                        setwareHouseId(selectedItem.value);
                                                        setwareHousePincode(selectedItem.pincode);
                                                    }

                                                    // Notify react-hook-form about the change
                                                    trigger("warehouse");
                                                    setValue("warehouse", selectedValue, { shouldValidate: true });
                                                }}
                                            >
                                                <option value="">Select Warehouse</option>
                                                {wareHouseList.map((item) => (
                                                    <option key={item.value} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>

                                            {/* Dropdown arrow */}
                                            <div className="pointer-events-none absolute inset-y-0 right-2 top-5 flex items-center">
                                                <svg
                                                    className={`w-4 h-4 ${isDarkMode ? "text-white" : "text-darkmodeColor"}`}
                                                    fill="currentColor"
                                                    viewBox="0 0 20 20"
                                                >
                                                    <path d="M7 7l3-3 3 3H7zm6 6l-3 3-3-3h6z" />
                                                </svg>
                                            </div>

                                            {errors.warehouse && (
                                                <p className="text-red-500 text-sm mt-1">{errors.warehouse.message}</p>
                                            )}
                                        </div>

                                        <div>
                                            <label htmlFor="firstName" className="block text-sm font-medium mb-1">First Name</label>
                                            <input
                                                id="firstName"
                                                {...register("firstName")}
                                                className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                type="text"
                                                onChange={handleInputChange}
                                                placeholder="Enter first name"
                                            />
                                            {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName.message}</p>}
                                        </div>
                                        <div>
                                            <label htmlFor="lastName" className="block text-sm font-medium mb-1">Last Name</label>
                                            <input
                                                id="lastName"
                                                {...register("lastName")}
                                                className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                type="text"
                                                onChange={handleInputChange}
                                                placeholder="Last name"
                                            />
                                            {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName.message}</p>}
                                        </div>
                                        <div>
                                            <label htmlFor="email" className="block text-sm font-medium mb-1">Email</label>
                                            <input
                                                id="email"
                                                {...register("email")}
                                                className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                type="email"
                                                placeholder="Enter email"
                                            />
                                            {/* {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>} */}
                                        </div>
                                        <div>
                                            <label htmlFor="mobile" className="block text-sm font-medium mb-1">Mobile No.</label>
                                            <input
                                                id="mobile"
                                                maxLength="10"
                                                {...register("mobile")}
                                                className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                type="tel"
                                                onChange={handleInputChange}
                                                placeholder="Enter 10 digit mobile no."
                                            />
                                            {errors.mobile && <p className="text-red-500 text-sm mt-1">{errors.mobile.message}</p>}
                                        </div>
                                        {/* <div>
                                            <label htmlFor="address" className="block text-sm font-medium mb-1">Full Address</label>
                                            <input
                                                id="address"
                                                {...register("address")}
                                                className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                type="text"
                                                placeholder="Enter full address"
                                            />
                                            {errors.address && <p className="text-red-500 text-sm mt-1">{errors.address.message}</p>}
                                        </div> */}
                                        <div>
                                            <label htmlFor="address" className="block text-sm font-medium mb-1">Full Address</label>
                                            <Controller
                                                name="address"
                                                control={control}
                                                render={({ field }) => (
                                                    <GoogleAddressInput value={field.value} onChange={field.onChange} />
                                                )}
                                            />
                                            {errors.address && (
                                                <p className="text-red-500 text-sm mt-1">{errors.address.message}</p>
                                            )}
                                        </div>
                                        <div>
                                            <label htmlFor="pincode" className="block text-sm font-medium mb-1">Pincode</label>
                                            <input
                                                id="pincode"
                                                maxLength="6"
                                                {...register("pincode", {
                                                    onChange: (e) => {
                                                        handleInputChange(e);
                                                    }
                                                })}
                                                className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                type="text"
                                                placeholder="Enter pincode"
                                            />
                                            {errors.pincode && <p className="text-red-500 text-sm mt-1">{errors.pincode.message}</p>}
                                        </div>
                                        <div>
                                            <label htmlFor="city" className="block text-sm font-medium mb-1">City</label>
                                            <input
                                                id="city"
                                                {...register("city")}
                                                disabled
                                                className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                type="text"
                                                onChange={handleInputChange}
                                                placeholder="City"
                                            />
                                            {errors.city && <p className="text-red-500 text-sm mt-1">{errors.city.message}</p>}
                                        </div>
                                        <div>
                                            <label htmlFor="state" className="block text-sm font-medium mb-1">State</label>
                                            <input
                                                id="state"
                                                {...register("state")}
                                                disabled
                                                className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                type="text"
                                                onChange={handleInputChange}
                                                placeholder="State"
                                            />
                                            {errors.state && <p className="text-red-500 text-sm mt-1">{errors.state.message}</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className="flex flex-col md:flex-row gap-2 font-sans w-full">
                                    <div className="px-8 pt-6 pb-8 mb-4 flex-1  shadow-custom-light dark:shadow-custom-dark rounded-custom">
                                        <h2 className="text-xl font-bold mb-4 text-custom-blue flex items-center">
                                            <FaShoppingCart className="mr-2 text-custom-blue" />
                                            Order Details
                                        </h2>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                            <div>
                                                <label htmlFor="orderId" className="block text-sm font-medium mb-1">Order ID</label>
                                                <input
                                                    id="orderId"
                                                    {...register("orderId")}
                                                    onChange={handleInputChange}
                                                    className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                    type="text"
                                                    placeholder="Enter Order ID"
                                                />
                                                {errors.orderId && <p className="text-red-500 text-sm mt-1">{errors.orderId.message}</p>}
                                            </div>
                                            <div>
                                                <label htmlFor="invoiceAmount" className="block text-sm font-medium mb-1">Invoice Amount</label>
                                                <input
                                                    id="  "
                                                    {...register("invoiceAmount")}
                                                    className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                    type="text"
                                                    placeholder="Total Amount"
                                                />
                                                {errors.invoiceAmount && <p className="text-red-500 text-sm mt-1">{errors.invoiceAmount.message}</p>}
                                            </div>
                                            <div>
                                                <label htmlFor="paymentMode" className="block text-sm font-medium mt-4 mb-1">Payment Mode</label>
                                                <select
                                                    id="paymentMode"
                                                    {...register("paymentMode")}
                                                    className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                // onChange={handleInputChange}

                                                >
                                                    {/* <option value="">Select Payment Mode</option> */}
                                                    <option value="prepaid">Prepaid</option>
                                                    <option value="cod">COD</option>

                                                </select>
                                                {errors.paymentMode && <p className="text-red-500 text-sm mt-1">{errors.paymentMode.message}</p>}
                                            </div>

                                            <div>
                                                <label htmlFor="codAmount" className="block text-sm mt-4 font-medium mb-1">Amount</label>
                                                <input
                                                    id="codAmount"
                                                    {...register("codAmount")}
                                                    className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                    type="text"
                                                    placeholder="Amount"
                                                    disabled={paymentMode !== "cod"}
                                                />
                                                {errors.codAmount && <p className="text-red-500 text-sm mt-1">{errors.codAmount.message}</p>}
                                            </div>
                                            <div className='w-[450px]'>
                                                <label htmlFor="productDes" className="block text-sm mt-4 font-medium mb-1">Product Descripition</label>
                                                <input
                                                    id="productDes"
                                                    {...register("productDes")}
                                                    className={`p-2 appearance-none shadow-custom-light rounded-custom border md:w-full w-[62%] focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                    type="text"
                                                    placeholder="Product Description"
                                                />
                                                {errors.productDes && <p className="text-red-500 text-sm mt-1">{errors.productDes.message}</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="px-8 pt-6 pb-8 mb-4 flex-1 font-sans dark:shadow-custom-dark  shadow-custom-light rounded-custom">
                                        <h2 className="text-xl font-bold mb-4 text-custom-blue flex items-center">
                                            <FaBox className="mr-2 text-custom-blue" />
                                            Box Details (in Grams)
                                        </h2>
                                        <div className="grid grid-cols-1 gap-2">
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
                                                <div>
                                                    <label htmlFor="weight" className="block text-sm font-medium mb-1">Weight</label>
                                                    <input
                                                        id="weight"
                                                        type="number"
                                                        step="0.01"
                                                        // step={0.01}
                                                        {...register("weight")}
                                                        className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                        placeholder="Weight"
                                                    />
                                                    {errors.weight && <p className="text-red-500 text-sm mt-1">{errors.weight.message}</p>}
                                                </div>
                                                <div>
                                                    <label htmlFor="boxQty" className="block text-sm font-medium mb-1">Box Quantity</label>
                                                    <input
                                                        id="boxQty"
                                                        value={1}
                                                        disabled
                                                        // {...register("boxQty")}
                                                        className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                        type="number"
                                                        step="0.01"
                                                        placeholder="Box Quantity"
                                                    />
                                                    {/* {errors.boxQty && <p className="text-red-500 text-sm mt-1">{errors.boxQty.message}</p>} */}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-4">
                                                <div>
                                                    <label htmlFor="length" className="block text-sm font-medium mb-1">Length</label>
                                                    <input
                                                        id="length"
                                                        {...register("length")}
                                                        className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                        type="number"
                                                        step="0.01"
                                                        placeholder="Length"
                                                    />
                                                    {errors.length && <p className="text-red-500 text-sm mt-1">{errors.length.message}</p>}
                                                </div>
                                                <div>
                                                    <label htmlFor="width" className="block text-sm font-medium mb-1">Width</label>
                                                    <input
                                                        id="width"
                                                        {...register("width")}
                                                        className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                        type="number"
                                                        step="0.01"
                                                        placeholder="Width"
                                                    />
                                                    {errors.width && <p className="text-red-500 text-sm mt-1">{errors.width.message}</p>}
                                                </div>
                                                <div>
                                                    <label htmlFor="height" className="block text-sm font-medium mb-1">Height</label>
                                                    <input
                                                        id="height"
                                                        {...register("height")}
                                                        className={`p-2 appearance-none shadow-custom-light rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                                                        type="number"
                                                        step="0.01"
                                                        placeholder="Height"
                                                        onChange={handleInputChange}
                                                    />
                                                    {errors.height && <p className="text-red-500 text-sm mt-1">{errors.height.message}</p>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex justify-center mb-3">
                                    <button
                                        type="submit"
                                        className="w-full md:w-[40%] bg-customPurple hover:bg-purple-700 text-white py-2 rounded-md flex items-center justify-center"
                                    >
                                        {isSubmitting ? <Spinner /> : 'Add Shipment'}
                                        <FaCalculator className="ml-2" />
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <ViewRateForword
                    isopen={isPopupOpen}
                    onClose={handleClose}
                    data={tableData}
                    reqBody={reqBody}
                />
            </div>
        </>
    )
}
